/**
 * Google map not supported country list
 */
export const GoogleMapNotSupportCountry: string[] = [
    'KP',
    'KR',
];
